import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { FruitNinjaGameCoreService } from './fruit-ninja-game-core.service';
import { FruitNinjaGameSelectorComponent } from './fruit-ninja-game-selector/fruit-ninja-game-selector.component';

@NgModule({
  declarations: [FruitNinjaGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [FruitNinjaGameCoreService],
  exports: [FruitNinjaGameSelectorComponent],
})
export class FruitNinjaGameCoreModule {}
